<template>
    <PopForm class="form-box" :state="isShow" :width="width" body-max-height="350px">
        <template slot="title">
            <span v-html="title+proName"></span>
            <span class="el-icon-close fr close" @click="closeForm"></span>
        </template>
        <div class="searchBox">
            <slot name="search">
                <el-form :inline="true" class="">
                    <el-form-item>
                        <el-select v-model="searchCid" placeholder="请选择">
                            <el-option value="" label="所有分类"></el-option>
                            <el-option
                                    v-for="item in categoryListData"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-input v-model="searchValue" :placeholder="'请输入'+proName+'名称'"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchEvent">搜索</el-button>
                    </el-form-item>
                </el-form>
            </slot>
        </div>
        <el-table :data="listData" height="300" ref="listTable" class="table-box"
                  highlight-current-row
                  @current-change="handleCurrentChange" @selection-change="handleSelectionChange"
                  @cell-click="selectedRow"
                  style="width: 100%">
            <el-table-column
                    type="selection"
                    width="50"
                    :selectable="selectIsDisabled">
            </el-table-column>
            <el-table-column
                    prop="title"
                    :label="proName">
                <template slot-scope="scope">
                    <div class="col-title">
                        <span class="title-text">{{scope.row.title}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="售价">
            </el-table-column>
            <el-table-column
                    prop="create_datetime"
                    label="创建时间">
            </el-table-column>
        </el-table>
        <template v-slot:foot>
            <div class="popFoot">
                <div class="page-box">
                    <el-pagination
                            @size-change="loadProductList"
                            @current-change="loadProductList"
                            :current-page="page.nowPage"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.count">
                    </el-pagination>
                </div>
                <div class="tools-box">
                    <el-button @click="closeForm">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </div>
        </template>
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "SelectProduct",
        components: {PopForm},
        model: {
            event: "stateChange",
            prop: "isShow",
        },
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "添加"
            },
            width: {
                type: String,
                default: "750px"
            },
            selectedList: {
                type: Array,
                default: () => [],
            },
            proType: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            proName: "",
            listData: [],
            categoryListData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            searchValue: "",
            searchCid: "",

            selectedProduct: [],
        }),
        mounted: function () {

        },
        methods: {
            initData: function () {
                if(this.proType === 1) {
                    this.proName = "项目";
                }else if(this.proType === 2) {
                    this.proName = "产品";
                }else if(this.proType === 5) {
                    this.proName = "卡项";
                }else{
                    this.proName = "";
                    return false;
                }
                this.loadCategoryList();
                this.loadProductList();
            },
            //加载服务列表
            loadProductList: function () {
                obj.postData("store_vip/get_product_list", {
                    keyword: this.searchValue,
                    cid: this.searchCid,
                    pro_type: this.proType,
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                }, res => {
                    if(res.errcode === 0) {
                        this.listData = res.data;
                        this.page.count = res.count;
                    }else
                        obj.message.error(res.errdesc);
                });
            },
            //加载分类列表
            loadCategoryList: function () {
                obj.postData("store_vip/get_product_category", {pro_type: this.proType}, res => {
                    if(res.errcode === 0)
                        this.categoryListData = res.data;
                });
            },
            //关闭
            closeForm: function () {
                this.$emit("stateChange", false);
            },
            //选中行
            handleCurrentChange: function (row) {
                // this.$refs.listTable.toggleRowSelection(row);
            },
            //选择变化
            handleSelectionChange: function (data) {
                this.selectedProduct = data;
            },
            //确定
            submitSave: function () {
                this.$emit("done", this.selectedProduct);
                this.closeForm();
            },
            //搜索
            searchEvent: function () {
                this.page.nowPage = 1;
                this.loadProductList();
            },
            //设置排除ID
            selectIsDisabled: function (row, index) {
                let tmpId = row.id;
                for (let key in this.selectedList){
                    if(tmpId === this.selectedList[key].id){
                        return false;
                    }
                }
                return true;
            },
            //点击行
            selectedRow: function (data) {
                if(this.selectIsDisabled(data))
                    this.$refs.listTable.toggleRowSelection(data);
            }
        },
        watch: {
            isShow: function (val) {
                if(val) {
                    this.initData();
                }
            }
        }
    }
</script>

<style scoped>
    .close{
        font-weight: bold;
    }

    .el-form--inline .el-form-item{
        margin-bottom: 0px;
    }
    .table-box::before {
        height: 0px;
    }
    .table-box{
        height: 320px;
    }
    .col-title{

    }
    .col-title>.thumb{
        height: 40px;
        width: 40px;
        margin-right: 5px;
        float: left;
    }
    .col-title>.title-text{
        height: 40px;
        line-height: 40px;
    }
    .page-box{
        text-align: right;
    }
</style>
